// extracted by mini-css-extract-plugin
export default {"ageInput":"AgeSelectInputNumber_ageInput__pQ+dR"};